export default {
  rango: {
    inicio: '',
    fin: ''
  },
  rangoHistorial: { //para la sección historial de pedidos
    inicio: '',
    fin: ''
  },
  rangoComparar: {
    inicio: '',
    fin: ''
  },
  tipo: 'pedidos',
  horaInicio: 6,
  pedidos: [],
  pedidosHistorial: [],
  pedidosComparar: [],
  filtros: {
    canalVenta: [
      {
        text: 'Online Web',
        value: 'propio'
      },
      {
        text: 'Directorio',
        value: 'directorio'
      },
      {
        text: 'Tpv',
        value: 'tpv'
      },
    ],
    formaPago: [
      {
        text: 'Tarjeta domicilio',
        value: 'tarjeta_domicilio'
      },
      {
        text: 'Tarjeta online',
        value: 'tarjeta_online'
      },
      {
        text: 'Efectivo',
        value: 'efectivo'
      },
      {
        text: 'Pago en local',
        value: 'local'
      },
      {
        text: 'Tarjeta local',
        value: 'tarjeta_local'
      },
      {
        text: 'Otro',
        value: 'otro'
      },
      {
        text: 'Multiple',
        value: 'multiple'
      },
    ],
    modo: [
      {
        text: 'Recoger',
        value: 'recoger'
      },
      {
        text: 'Domicilio',
        value: 'domicilio'
      },
      {
        text: 'Mesa',
        value: 'mesa'
      },
      {
        text: 'Mostrador',
        value: 'mostrador'
      },
    ]
  }
}